module.exports = __webpack_public_path__ + "static/media/natural-coconut.c47ad050.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/products/nutrition-facts/natural-coconut.png
// module id = 171
// module chunks = 0